import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import { BaseComponent } from 'src/app/modules/core/components/bases/base-component';
import { takeUntil } from 'rxjs/operators';
var States;
(function (States) {
    States[States["Add"] = 0] = "Add";
    States[States["Edit"] = 1] = "Edit";
    States[States["Idle"] = 2] = "Idle";
})(States || (States = {}));
export class CertificatesRowComponent extends BaseComponent {
    constructor(plantingSiteService, cdr) {
        super();
        this.plantingSiteService = plantingSiteService;
        this.cdr = cdr;
        this.rowCertificate = { isShow: true };
        this.original = { isShow: true };
        this.certificates = [];
        this.plantingSiteAreas = [];
        this.customers = [];
        this.discardValues$ = new Subject();
        this.showCustomerOnSite$ = new Subject();
        this.onSave = new EventEmitter();
        this.onDelete = new EventEmitter();
        this.onEditing = new EventEmitter();
        this.editing = false;
        this.wasSubmitted = false;
        this.states = States;
        this.modalCustomer = new EventEmitter();
    }
    set newCustomer(newCus) {
        if (newCus) {
            this.selectedAddCust = newCus.name;
            this.keepNewCustomerId = newCus.id;
        }
    }
    get max() {
        if (!this.original)
            return;
        let count = this.original.count;
        let misc = this.remainMax;
        if (this.isEditRow) {
            return misc === 0 ? count : count + misc;
        }
        else {
            return misc;
        }
    }
    get showEditing() {
        return this.editing || !this.isEditRow;
    }
    ngOnInit() {
        this.original = Object.assign({}, this.rowCertificate);
        this.state = this.isEditRow ? this.states.Idle : this.states.Add;
        this.original = this.isEditRow ? Object.assign({}, this.rowCertificate) : this.original = { isShow: true };
        this.rowCertificate = Object.assign({}, this.rowCertificate);
        this.discardValues$
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((isFromEditRow) => {
            if (this.shouldDiscardChangesOnCreateRow(this.isEditRow, isFromEditRow)) {
                this.rowCertificate = { isShow: true };
                this.selectedAddCust = null;
                this.selectNewCus.clearModel();
                this.markClean();
            }
            else if (this.isEditRow) {
                this.revertChanges();
            }
        });
        this.showCustomerOnSite$.subscribe((cer) => {
            if (this.rowCertificate.customerId == cer.customerId) {
                this.rowCertificate.isShow = cer.isShow;
            }
        });
    }
    ngAfterViewInit() {
        //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        //Add 'implements AfterViewInit' to the class.
        this.cdr.detectChanges();
        setTimeout(() => {
            this.checkLimitTrees(this.selectedEditAreaId);
        }, 1);
        setTimeout(() => {
            this.checkLimitTrees(this.selectedPlantingSiteArea);
        }, 1);
    }
    toggleShow() {
        if (this.isEditRow)
            return;
        this.rowCertificate.isShow = !this.rowCertificate.isShow;
    }
    applyChanges() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isInvalidDirectives.some(value => value.isInvalid)) {
                this.wasSubmitted = true;
                return;
            }
            let custSelected = this.customers.find(val => val.id === this.selectedEditCust);
            if (custSelected) {
                this.rowCertificate.customerId = this.selectedEditCust;
                this.rowCertificate.customerName = custSelected.name;
            }
            else {
                custSelected = this.customers
                    .find(val => val.name === this.rowCertificate.customerName);
                this.rowCertificate.customerId = custSelected.id;
            }
            let areaSelected = this.plantingSiteAreas.find(area => area.id == this.selectedEditAreaId);
            if (areaSelected) {
                this.rowCertificate.plantingSiteAreaId = areaSelected.id;
                this.rowCertificate.plantingSiteAreaName = areaSelected.name;
            }
            else {
                areaSelected = this.plantingSiteAreas.find(area => area.name == this.rowCertificate.plantingSiteAreaName);
                this.rowCertificate.plantingSiteAreaId = areaSelected.id;
            }
            let id = yield this.plantingSiteService.updateCertificate(this.rowCertificate);
            this.showCustomerOnSite$.next(this.rowCertificate);
            // if update fail. app will not reach the lines below
            this.original = Object.assign({}, this.rowCertificate);
            this.onEditing.emit(this.rowCertificate);
            if (id) {
                this.editing = false;
                this.state = this.states.Idle;
                this.markClean();
            }
            this.discardValues$.next(this.isEditRow);
        });
    }
    revertChanges() {
        this.editing = false;
        this.state = this.states.Idle;
        this.rowCertificate = this.original;
        this.markClean();
    }
    openEdit() {
        this.discardValues$.next(this.isEditRow);
        this.selectedEditCust = this.rowCertificate.customerName;
        this.selectedEditAreaId = this.rowCertificate.plantingSiteAreaId;
        this.editing = true;
        this.state = this.states.Edit;
        this.original = Object.assign({}, this.rowCertificate);
        this.rowCertificate = Object.assign({}, this.rowCertificate);
    }
    openDelete() {
        this.discardValues$.next(this.isEditRow);
        this.original = Object.assign({}, this.rowCertificate);
        this.onDelete.emit(this.rowCertificate);
    }
    add() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isInvalidDirectives.some(value => value.isInvalid)) {
                this.wasSubmitted = true;
                return;
            }
            this.setCustomer();
            let newRowCertificate = yield this.plantingSiteService.addCertificate(this.selectedPlantingSiteArea, this.rowCertificate);
            this.discardValues$.next(this.isEditRow);
            this.showCustomerOnSite$.next(this.rowCertificate);
            // if update fail. app will not reach the lines below
            this.rowCertificate.id = newRowCertificate.id;
            this.rowCertificate.code = newRowCertificate.code;
            this.onSave.emit(Object.assign({}, this.rowCertificate));
            this.rowCertificate = { isShow: true };
            this.selectedAddCust = null;
            this.selectNewCus.clearModel();
            this.markClean();
        });
    }
    markClean() {
        if (!this.isEditRow)
            this.original = { isShow: true };
        this.form.control.markAsPristine();
        this.form.control.markAsUntouched();
        this.wasSubmitted = false;
    }
    showCustomer() {
        this.modalCustomer.emit();
    }
    setCustomer() {
        let custSelected = this.customers.find(val => val.id === this.selectedAddCust);
        if (custSelected) {
            this.rowCertificate.customerName = custSelected.name;
            this.rowCertificate.customerId = this.selectedAddCust;
        }
        else {
            if (this.keepNewCustomerId) {
                custSelected = this.customers.find(val => val.id === this.keepNewCustomerId);
                this.rowCertificate.customerId = custSelected.id;
                this.rowCertificate.customerName = custSelected.name;
            }
        }
        let areaSelected = this.plantingSiteAreas.find(area => area.id === this.selectedPlantingSiteArea);
        if (areaSelected) {
            this.rowCertificate.plantingSiteAreaId = areaSelected.id;
            this.rowCertificate.plantingSiteAreaName = areaSelected.name;
        }
    }
    shouldDiscardChangesOnCreateRow(isEditRow, isFromEditRow) {
        return !isEditRow && isFromEditRow;
    }
    checkLimitTrees(plantingSiteAreaId) {
        if (plantingSiteAreaId !== undefined) {
            const theArea = this.plantingSiteAreas.find(area => area.id == plantingSiteAreaId);
            let sumPlantingSiteArea = theArea.species.reduce((acc, cur) => acc + cur.count, 0);
            this.remainMax = sumPlantingSiteArea - theArea.certificates.reduce((acc, cur) => acc + cur.count, 0);
        }
    }
}
